import { render } from "./LightboxProductsIdentified.vue?vue&type=template&id=8118d82a"
import script from "./LightboxProductsIdentified.vue?vue&type=script&lang=js"
export * from "./LightboxProductsIdentified.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__